import ClockList from "@/components/Clock/ClockList.vue";
import ClockEdit from "@/components/Clock/ClockEdit.vue";

import ClockListNew from "@/components/Clock/ClockListNew.vue";

export default [
    {
        path: 'clock',
        alias: '',
        name: 'All Clocks',
        redirect: "/clock/list",
        components: {
            page: ClockListNew,
        },
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "filter",
                name: "Clock Filter",
                components: {
                    // ... NONE
                    // OPEN CERTAIN CLOCKS
                }
            },
            {
                path: "list/:filter?",
                name: "Clock List List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "edit/:type/:id?",
                name: "Clock Edit",
                components: {
                    modal: ClockEdit,
                }
            },
            {
                path: "stop/:type/:id?",
                name: "Clock Stop",
                components: {
                    modal: ClockEdit
                }
            }
        ]
    }
];